import cn from 'classnames';
import { forwardRef, HTMLProps } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { PlusIcon } from '../../assets/svg/plus';
import { stringToColor } from '../../pages/manager/body/dashboard/dashboard-helpers';
import { SizeType } from '../../types/props';
import { IconButton } from '../icon-button/icon-button';
import { InputFile } from '../input-file/input-file';
import s from './avatar.module.css';

interface Props extends Omit<HTMLProps<HTMLDivElement>, 'size' | 'onChange'> {
  size?: SizeType;
  onDelete?: (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
  onChange?: (e: File[]) => void;
  img?: string;
  name: string;
  color?: string;
}

export const Avatar = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { size = 'sm', className, onDelete, onChange, img, name, color, ...other } = props;

  const classNames = cn(s.component, className, s[size]);

  const nameParts = name.split(' ');
  const letters = nameParts
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  return (
    <InputFile onChange={onChange} types={['image/*']} data-testid={`${other.id}-input-file`}>
      <div
        {...other}
        ref={ref}
        className={classNames}
        style={{ backgroundColor: color || stringToColor(name) }}
        data-testid={other.id}
      >
        {img ? (
          <img src={img} alt="avatar" className={s.img} />
        ) : (
          <div className={cn(s.letters, s[size])}>{letters}</div>
        )}
        {onDelete && (
          <IconButton className={s.delete} onClick={onDelete} variant="ghost" size={size}>
            <AiOutlineClose />
          </IconButton>
        )}
        {onChange && (
          <IconButton className={s.add}>
            <PlusIcon />
          </IconButton>
        )}
      </div>
    </InputFile>
  );
});
